// extracted by mini-css-extract-plugin
export default {"navbar-link":"NavBarLink_navbar-link__4oUt-","navlink-active":"NavBarLink_navlink-active__hG8MM"};